import {lazy} from 'react';

const AppointmentRequestSuccess = lazy(
  () => import('./AppointmentRequestSuccess'),
);

export default AppointmentRequestSuccess;
